import { Flex, GameTileThumbnail } from '@/common/components';
import { createComponent, IntrinsicProps } from '@/common/util/templateHelpers';
import { Playlist, PlaylistBasic } from '@/util/formatters';
import Link from 'next/link';

import style from './index.module.scss';

interface PlaylistTileProps extends IntrinsicProps {
  playlist: Playlist | PlaylistBasic;
}

export default createComponent<PlaylistTileProps>('PlaylistTile',
  { style },
  function PlaylistTile ({ className }, props) {
    return (
      <Flex directionColumn className={className}>
        <Link
          href={props.playlist.path}
          passHref={true}
        >
          <a data-id={props.id}>
            <Flex fit directionColumn>
              <Flex className='PlaylistTile__Content GameTile'>
                <GameTileThumbnail
                  src={props.playlist.thumbnailUrl}
                  alt={props.playlist.title}
                />
              </Flex>
              <Flex justifyCenter className='PlaylistTile__Title'>
                <span>{props.playlist.title}</span>
              </Flex>
            </Flex>
          </a>
        </Link>
      </Flex>
    );
  });
